export type NavTab = 'chat' | 'prompts' | 'agents' | 'tools' | 'admin';
export type ScopeFilter = 'all' | 'global' | 'personal' | `project:${string}`;

export interface EditingResource {
  type: 'prompt' | 'agent' | 'project-settings';
  id?: string; // undefined = creating new
}

export interface NavigationState {
  tab: NavTab;
  projectId?: string;
  isPersonal: boolean;
}

/** Extract project ID from a project-scoped filter, or undefined */
export function getProjectIdFromFilter(filter: ScopeFilter): string | undefined {
  if (filter.startsWith('project:')) return filter.slice(8);
  return undefined;
}
